export async function polyfill(): Promise<void> {
  const imports: Array<Promise<any>> = []

  if (!Array.prototype.find) {
    imports.push(import(/* webpackChunkName: "arrayFind" */ './arrayFind'))
  }

  if (!Array.from) {
    imports.push(import(/* webpackChunkName: "arrayFrom" */ './arrayFrom'))
  }

  if (!HTMLElement.prototype.matches) {
    imports.push(
      import(/* webpackChunkName: "elementMatches" */ './elementMatches')
    )
  }

  if (typeof Object.assign !== 'function') {
    imports.push(
      import(/* webpackChunkName: "objectAssign" */ './objectAssign')
    )
  }

  if (typeof window.CustomEvent !== 'function') {
    imports.push(import(/* webpackChunkName: "customEvent" */ './customEvent'))
  }

  if (typeof window.Promise !== 'function') {
    imports.push(
      import(
        /* webpackChunkName: "es6Promise" */ 'es6-promise'
      ).then(({ polyfill }) => polyfill())
    )
  }

  await Promise.all(imports)
}
